(function () {
  // ---------- DOM helpers ----------
  const getBadges = () => Array.from(document.querySelectorAll('[data-cart-count-badge]'));
  const getDrawerQtyEl = () => document.querySelector('[data-cart-items-qty]');

  function setBadges(count) {
    getBadges().forEach(badge => {
      badge.textContent = String(count || 0);
      badge.classList.toggle('hidden', !(Number(count) > 0));
    });
  }

  function setDrawerItems(count) {
    const el = getDrawerQtyEl();
    if (!el) return;
    const tpl = el.getAttribute('data-items-text') || '[count] items';
    el.textContent = tpl.replace('[count]', String(count || 0));
    el.classList.toggle('hidden', !(Number(count) > 0));
  }

  let inflight = null;
  async function fetchCartAndRender() {
    // 去抖：并发时复用同一次请求
    if (!inflight) {
      inflight = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .catch(() => null)
        .finally(() => { inflight = null; });
    }
    const cart = await inflight;
    const count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    setBadges(count);
    setDrawerItems(count);
    return cart;
  }

  // ---------- Hook network (fetch & XHR) ----------
  const CART_PATH_RE = /(\/cart\/(add|change|update|clear)\.js)(\?|$)/;

  function hookFetch() {
    if (!window.fetch || window.fetch.__cartBadgePatched) return;
    const _fetch = window.fetch;
    window.fetch = async function patchedFetch(input, init) {
      const p = _fetch(input, init);
      try {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const method = (init && (init.method || init.method === '' ? init.method : '')) || (input && input.method) || '';
        const res = await p;
        // 成功命中购物车写操作后刷新
        if (CART_PATH_RE.test(url) && (res.ok || res.status === 422 || res.status === 400 || res.status === 409)) {
          // 422/400 也可能改变了行项目或被 app 拦截，稳妥刷新
          queueMicrotask(fetchCartAndRender);
        }
        return res;
      } catch (e) {
        return p;
      }
    };
    window.fetch.__cartBadgePatched = true;
  }

  function hookXHR() {
    const XHR = window.XMLHttpRequest;
    if (!XHR || XHR.prototype.__cartBadgePatched) return;

    const open = XHR.prototype.open;
    const send = XHR.prototype.send;

    XHR.prototype.open = function(method, url) {
      this.__cartBadgeURL = url || '';
      this.__cartBadgeMethod = method || '';
      return open.apply(this, arguments);
    };

    XHR.prototype.send = function() {
      this.addEventListener('loadend', () => {
        try {
          if (CART_PATH_RE.test(this.__cartBadgeURL)) {
            queueMicrotask(fetchCartAndRender);
          }
        } catch (e) {}
      });
      return send.apply(this, arguments);
    };

    XHR.prototype.__cartBadgePatched = true;
  }

  // ---------- Fallbacks ----------
  // 一些主题/区块会派发这些事件
  document.addEventListener('cart:updated', fetchCartAndRender);
  document.addEventListener('cart:refresh', fetchCartAndRender);
  document.addEventListener('cart:change', fetchCartAndRender);

  // 抽屉/区块动态替换后，重新同步（Palo Alto 会用 template 注入）
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        // 出现新的 cart UI 时，拉一次最新数量并重绑引用
        fetchCartAndRender();
        break;
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // ---------- Init ----------
  try {
    hookFetch();
    hookXHR();
  } catch (e) {
    // 忽略 hook 失败
  }

  // 首次进入同步
  fetchCartAndRender();
})();
